import useAuthStore from './store/authStore';
import { auth } from './lib/firebase';
import { useEffect } from 'react';
import ChatWindow from './ChatWindow';
import Login from './Login';
import { onAuthStateChanged } from 'firebase/auth';

function App() {
  const { setUserDetails, setUser, user, updateLastActiveTime } = useAuthStore(
    (state) => ({
      setUserDetails: state.setUserDetails,
      user: state.user,
      setUser: state.setUser,
      updateLastActiveTime: state.updateLastActiveTime,
    })
  );

  useEffect(() => {
    document.title = 'VP';

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
        setUserDetails(user.uid);
        updateLastActiveTime(user.uid);
      } else {
        setUser(null);
      }
    });

    const updateLastActiveInterval = setInterval(() => {
      if (auth.currentUser) {
        updateLastActiveTime(auth.currentUser.uid);
      }
    }, 2 * 60 * 1000); //2 * 60 * 1000

    // ? Force Logout if Window is Focused Out
    // let delayedSignout;

    // window.addEventListener('blur', async () => {
    //   delayedSignout = setInterval(() => {
    //     if (auth.currentUser) {
    //       updateLastActiveTime(auth.currentUser.uid);
    //     }
    //   }, (2 * 60 * 1000)); //2 * 60 * 1000
    //   await signOut(auth);
    //   setUser(null);
    // });

    // window.addEventListener('focus', async () => {
    //   clearInterval(delayedSignout);
    // });

    return () => {
      clearInterval(updateLastActiveInterval);
      unsubscribe();
    };
  }, []);

  return <>{user ? <ChatWindow /> : <Login />}</>;
}

export default App;
